<template>
  <div class="collection_panel_container" v-show="isShow">
    <div class="modal"></div>
    <div class="collection_body_container">
      <iframe
        src=""
        class="collection_panel_iframe"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        v-if="isOcx"
      ></iframe>
      <div class="collection_body content-bg-color">
        <div class="condition_left_content page-background-color">
          <h3 style="font-weight: 600">
            {{ $t("video.title.selectedCamera") }}
          </h3>
          <el-scrollbar tag="ul" class="camera_data">
            <li v-for="(item, key) in cameraData" :key="key">
              <i :class="['security', hasCameraTypeClass(item.cameraType)]"></i>
              <label
                :title="item.name || item.cameraName"
                class="camera-name"
                >{{ item.name || item.cameraName }}</label
              >
            </li>
          </el-scrollbar>
        </div>
        <div class="condition_right_content">
          <h3 style="font-weight: 600">
            <span>{{ $t("video.label.addFavoritea") }}</span>
            <i
              @click="handleClose"
              class="el-icon-close"
              style="font-weight: normal"
            ></i>
          </h3>
          <div class="condition_list_container">
            <div style="text-align: center; margin-bottom: 12px">
              <el-input
                size="small"
                style="width: 290px"
                :placeholder="$t('video.placeholder.addOrSeachFavorite')"
                v-model="keyword"
                @input="handleInput"
              ></el-input>
            </div>
            <el-scrollbar tag="ul" class="list_data" ref="scrollBar">
              <template>
                <!--{{obj}}-->
                <li
                  v-for="item in mData"
                  :class="[
                    active === item.id ? 'active' : '',
                    favoriteActive === item.id ? 'favorite' : '',
                  ]"
                  @click="handleActive(item.id)"
                  :key="item.id"
                >
                  <label :title="item.name">{{ item.name }}</label>
                  <!-- 包含所有设备展示已收藏 -->
                  <template v-if="item.children && hasCamera(item)">
                    <div class="btn">
                      {{ $t("video.label.isAdd") }}
                    </div>
                  </template>
                  <template v-else>
                    <div class="btn" @click="addFavorite(item.id)">
                      {{ $t("video.label.addFavoritea") }}
                    </div>
                  </template>
                </li>
              </template>
            </el-scrollbar>
          </div>
          <div style="padding: 9.5px 25px" v-if="keyword">
            <button class="add_collection_button" @click="handleSave">
              <i class="security icon-cc-plus-square"></i>
              <span>{{ $t("video.label.newAdd") }}</span>
              <span>“{{ keyword }}”</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "../../api";
export default {
  name: "add-collection-panel",
  props: {
    isOcx: {
      type: Boolean,
      default: false,
    },
    camData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      keyword: "",
      active: "",
      isShow: false,
      mData: [],
      favoriteActive: "",
      cameraData: [],
    };
  },
  watch: {
    cameraData: function (newVal) {
      if (newVal) {
        this.favoriteActive = "";
      }
    },
  },
  mounted() {
    // if (this.isOcx && this.camData) {
    //   this.isShow = true;
    //   this.keyword = "";
    //   this.active = "";
    //   this.cameraData = this.camData;
    //   this.queryCollectionData();
    // }
  },
  methods: {
    handleActive(val) {
      this.active = val;
    },
    open(data) {
      this.cameraData = data;
      this.isShow = true;
      this.keyword = "";
      this.active = "";
      this.queryCollectionData();
    },
    handleClose() {
      this.isShow = false;
      this.$emit("refresh");
      // this.$store.dispatch('setFavoriteAction', null)
    },
    queryCollectionData() {
      this.$log.debug(
        "####",
        this.cameraData.map((item) => item.thirdCameraId)
      );
      this.$fetch(api.queryFolderList, {
        favoriteSeach: this.keyword,
        cameraIdList: this.cameraData.map((item) => item.thirdCameraId),
      }).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        const _data = res.returnObj;
        this.$log.debug("mData", _data);
        this.mData = _data;
        if (this.mData && this.mData["one"]) {
          this.active = this.mData["one"][0].favoriteId;
        }
      });
    },
    handleSave() {
      if (!this.keyword) {
        return;
      }
      let _favoriteCameraList = this.cameraData.map((item) => {
        return {
          favCameraName: item.name || item.cameraName,
          thirdCameraId: item.thirdCameraId,
        };
      });
      let AddFolderVo = {};
      AddFolderVo.folderName = this.keyword;
      AddFolderVo.superFolderCode = -1; // 上级文件夹编号
      this.$fetch(api.addFolder, AddFolderVo).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.$log.debug(
          "####",
          this.cameraData.map((item) => item.thirdCameraId)
        );
        this.$fetch(api.queryFolderList).then((res) => {
          if (!res.success) {
            this.$message.error(res.msgContent);
            return;
          }
          const _data = res.returnObj;
          this.$log.debug("mData", _data);
          let favId = "";
          this.mData = _data;
          _data.some((item) => {
            if (item.name === this.keyword) {
              favId = item.id;
              return true;
            }
          });
          this.addFavorite(favId);
        });
      });
    },
    hasCamera(item) {
      let children = [];
      if (!item.children) {
        return false;
      }
      children = item.children.map((fav) => {
        return fav.thirdCameraId;
      });
      let result = true;
      this.cameraData.some((camera) => {
        if (children.indexOf(camera.thirdCameraId) === -1) {
          result = false;
          return true;
        }
        return false;
      });
      return result;
    },
    handleInput(val) {
      if (val) {
        this.$refs.scrollBar.update();
      }
      this.queryCollectionData();
    },
    addFavorite(favoriteId) {
      console.log(this.cameraData, "=====cameraData");
      // let _favoriteCameraList = this.cameraData.map(item => {
      //   return {
      //     favCameraName: item.name || item.cameraName,
      //     originalMonitorPointCode: '',
      //     folderCode: favoriteId,
      //     monitorPointsInfo: item.thirdCameraId
      //   }
      // });
      let monitorPointsInfo = [];
      this.cameraData.map((item) => {
        monitorPointsInfo.push({
          monitorPointCode: item.id, // 监控点编号
          monitorPointThirdCode: item.thirdCameraId, // 监控点第三方编号
          monitorPointName: item.name, // 监控点名称
          monitorPointType: item.cameraType, // 监控点类型
        });
      });
      let MonitorPointsVo = {
        folderCode: favoriteId, // 文件夹编号
        originalMonitorPointCode: "", // 监控点所属原文件夹编号
        monitorPointsInfo,
      };
      this.$log.debug("MonitorPointsVo：", MonitorPointsVo);
      this.$fetch(api.setMonitorPoints, MonitorPointsVo).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
          return;
        }
        this.$message.success(this.$t("video.message.setOk"));
        this.queryCollectionData();
        this.favoriteActive = favoriteId;
        // this.$emit('refresh')
      });
    },
    hasOpa(val) {
      return val === 0 ? "" : "opa";
    },
    hasCameraTypeClass(type) {
      switch (type) {
        case "0":
          return "icon-gun-machine";
        case "1":
          return "icon-gun-machine";
        case "2":
          return "icon-ball-machine ball";
        default:
          return "icon-gun-machine";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
@import "~@src/common/assets/style/ioc/pages/common.scss";
.collection_panel_container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  .modal {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #000;
    opacity: 0.5;
  }

  .collection_body_container {
    width: 688px;
    height: 500px;
    position: relative;
    @include set_theme_color(background-color, dialog-content-bg-color);
    .collection_panel_iframe {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
    }

    .collection_body {
      width: 100%;
      height: 100%;
      // background-color: $soc-color-background;
      // border: $soc-primary-color solid 2px;
      display: flex;
      flex-direction: row;
      .condition_left_content {
        .camera-name {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .condition_left_content,
      .condition_right_content {
        width: 50%;
        flex: 1;
        height: 100%;
        // background-color: #1a2137;
        display: flex;
        flex-direction: column;

        .camera_data {
          flex: 1;
          padding: 0;
          margin: 26px 0;
          list-style: none;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          li {
            height: 36px;
            padding: 0 19px;
            display: flex;
            flex-direction: row;
            align-items: center;

            label {
              flex: 1;
              font-size: 14px;
              line-height: 14px;
            }

            i {
              font-size: 14px;
              line-height: 14px;
              margin-right: 8px;

              &.ball {
                font-size: 12px;
                line-height: 14px;
              }
            }
          }
        }

        /*.condition_list_container {*/
        /*padding: 26px 0;*/
        /*display: flex;*/
        /*flex-direction: column;*/
        /*flex: 1;*/
        /*}*/

        h3 {
          margin: 0;
          padding: 15px 24px;
          line-height: 18px;
          font-size: 18px;
          font-weight: normal;
          border-bottom: $soc-border-color solid 1px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          i {
            font-size: 18px;
            color: #fff;
            margin-right: -4px;
            cursor: pointer;
          }
        }
      }

      .condition_right_content {
        background-color: transparent;
        display: flex;
        flex-direction: column;

        .add_collection_button {
          height: 32px;
          background-color: $soc-primary-color;
          color: #fff;
          display: flex;
          flex-direction: row;
          align-items: center;
          border: $soc-primary-color solid 1px;
          cursor: pointer;

          i {
            font-size: 17px;
            line-height: 20px;
            margin-right: 6px;
            margin-top: 2px;
          }

          line-height: 20px;
          border-radius: 2px;
        }

        .condition_list_container {
          overflow: auto;
          padding: 26px 0 0 0;
          display: flex;
          flex-direction: column;
          flex: 1;

          .list_data {
            display: flex;
            flex: 1;
            flex-direction: column;
            list-style: none;
            width: 84%;
            margin-left: 27px;

            li {
              width: 100%;
              height: 36px;
              display: flex;
              flex-direction: row;
              align-items: center;
              padding-left: 10px;
              cursor: pointer;
              // border-left: $soc-color-background solid 3px;
              .word_span {
                padding: 0 10px;
                font-size: 14px;
                color: $soc-font-color;
                line-height: 14px;

                &.isIcon {
                  padding: 0 5px 0 5px;
                }

                i {
                  font-size: 20px;
                  line-height: 20px;
                  margin-left: 0;
                }

                &.opa {
                  opacity: 0;
                }
              }

              &:hover {
                background-color: rgba(#465275, 0.4);
                cursor: pointer;

                .btn {
                  width: 72px;
                  background-color: $soc-primary-color;
                  opacity: 1;
                }

                .word_span {
                  padding-left: 10px;

                  &.isIcon {
                    padding-left: 5px;
                  }
                }
              }

              &.favorite {
                background: rgba(#465275, 0.4) !important;
                cursor: pointer;
                border-left: none !important;

                .btn {
                  width: 72px;
                  background-color: #586583 !important;
                }

                .word_span {
                  padding-left: 10px !important;
                }
              }

              &.active {
                cursor: pointer;
                border-left: $soc-primary-color solid 3px;
                background: linear-gradient(
                  to right,
                  rgba($soc-primary-color, 0.8),
                  $soc-color-background
                );
                background: -ms-linear-gradient(
                  left,
                  rgba($soc-primary-color, 0.8),
                  $soc-color-background
                );
                background: -webkit-linear-gradient(
                  left,
                  rgba($soc-primary-color, 0.8),
                  $soc-color-background
                );
                background: -moz-linear-gradient(
                  left,
                  rgba($soc-primary-color, 0.8),
                  $soc-color-background
                );

                .btn {
                  width: 72px;
                  background-color: $soc-primary-color;
                  opacity: 1;
                }

                .word_span {
                  padding-left: 7px;

                  &.isIcon {
                    padding-left: 2px;
                  }
                }
              }

              label {
                flex: 1;
                cursor: pointer;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .btn {
                height: 100%;
                line-height: 36px;
                text-align: center;
                background-color: #586583;
                /*width: 0;*/
                /*transition: width 0.3s;*/
                /*-webkit-transition: width 0.3s;*/
                opacity: 0;
                overflow: hidden;
              }
            }
          }
        }
      }
    }
  }
}
</style>
